<ng-template pTemplate="header">
  <span class="text-xl font-bold"
    >Lista prodotti da consegna numero ' inserire identificativo consegna'
  </span>
</ng-template>

<div class="tbl max-w-full">
  <p-table
    [value]="deliveryProducts"
    dataKey="am_id"
    [paginator]="true"
    paginatorDropdownAppendTo="body"
    #dt1
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="false"
    [loading]="loading"
    (onLazyLoad)="loadDeliveryProducts()"
    [totalRecords]="totalRecords"
    [(selection)]="selectedDeliveryProducts"
    [showCurrentPageReport]="true"
    [paginator]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr>
        <th>
          <p-tableHeaderCheckbox
            pTooltip="Attenzione! Verranno selezionati solo i prodotti selezionabili della pagina corrente."></p-tableHeaderCheckbox>
        </th>
        <th>Serial number</th>
        <th>Nome</th>
        <th>Brand</th>

        <!-- <th></th> -->
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-p>
      <tr>
        <td>
          <p-tableCheckbox [value]="p"></p-tableCheckbox>
        </td>
        <td>
          {{ p.serial_number.code || '-' }}
        </td>
        <td>
          {{ p.name || '-' }}
        </td>
        <td>
          {{ p.brand || '-' }}
        </td>
      </tr>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            colspan="4"
            class="text-center py-2">
            Nessun risultato.
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
